import React from 'react';
import classNameBind from 'classnames/bind';
import _isEqual from 'lodash/isEqual';
import Text from '../Text';
import styles from './TiledSelectionHorizontal.module.css';
import TileHorizontal from './components/TileHorizontal';
import Stack from '../Stack/Stack';

const bindClasses = classNameBind.bind(styles);

const TiledSelectionHorizontal = ({
  items,
  name,
  onChange,
  value,
  emptySelectionText,
  dataId,
  t,
} = {}) => {
  if (items.length === 0) {
    return (
      <div
        className={bindClasses('empty')}
        data-ppuc-id={`${dataId}.empty`}
      >
        <Text type="subdued">
          {t(emptySelectionText)}
        </Text>
      </div>
    );
  }

  return (
    <div className={bindClasses('wrapper')}>
      <Stack
        vertical
        fullWidth
        dataId={dataId}
        spacing="narrow"
      >
        {items.map(item => (
          <Stack.Item fill key={item.id}>
            <TileHorizontal
              id={item.id}
              key={item.id}
              name={item.name}
              info={item.info}
              icon={item.icon}
              disabled={item.disabled}
              checked={_isEqual(value, item.value)}
              onClick={() => {
                onChange({
                  target: {
                    name,
                    value: item.value,
                  },
                });
              }}
              dataId={`${dataId}.Tile`}
            />
          </Stack.Item>
        ))}
      </Stack>
    </div>
  );
};

TiledSelectionHorizontal.defaultProps = {
  value: [],
  emptySelectionText: 'TiledSelection.no-items-available',
  dataId: 'TiledSelectionHorizontal',
  t: () => {},
  onChange: () => {},
};

export { TiledSelectionHorizontal };
